import { render, staticRenderFns } from "./BillingUB04ChargeAddModal.vue?vue&type=template&id=344a6709&scoped=true&"
import script from "./BillingUB04ChargeAddModal.vue?vue&type=script&lang=js&"
export * from "./BillingUB04ChargeAddModal.vue?vue&type=script&lang=js&"
import style0 from "./BillingUB04ChargeAddModal.vue?vue&type=style&index=0&id=344a6709&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344a6709",
  null
  
)

export default component.exports